import { Contract } from "@ethersproject/contracts";
import { shortenAddress, useCall,useChainMeta, useEthers, useLookupAddress,useEtherBalance, ChainId } from "@usedapp/core";
import React, { useEffect, useState, createRef } from "react";

import {Button,MainStyle,Terms} from "./components";
import logo from "./ethereumLogo.png";

import { addresses, abis,deployments } from "@my-app/contracts";

import { ethers } from "ethers";
import { Accordion,Heading,Block,Modal,Loader,Text,Success,Error } from '@lidofinance/lido-ui'
import Header from './components/header';
import Footer from './components/footer';
import Staking from './components/staking';
import Landing from './components/landing';
import Soon from './components/soon';
import DogeDollar from './components/staking/dogedollar';
import {
  BrowserRouter,
  Routes,
  Route,
  Redirect,
  Switch,
  useNavigate,
  useMatch
} from "react-router-dom";

import BalanceViewer from "./components/staking/balances";
import staking from "./components/staking";
import { use } from "chai";


// console.log(routerDom)

const unizapabi = [{"inputs":[{"internalType":"address","name":"_router","type":"address"},{"internalType":"address","name":"_WETH","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"tokenAmountOutMin","type":"uint256"},{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"uint256","name":"tokenInAmount","type":"uint256"}],"name":"beefIn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"tokenAmountOutMin","type":"uint256"}],"name":"beefInETH","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"withdrawAmount","type":"uint256"}],"name":"beefOut","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"uint256","name":"withdrawAmount","type":"uint256"},{"internalType":"address","name":"desiredToken","type":"address"},{"internalType":"uint256","name":"desiredTokenOutMin","type":"uint256"}],"name":"beefOutAndSwap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"checkWETH","outputs":[{"internalType":"bool","name":"isValid","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"beefyVault","type":"address"},{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"uint256","name":"fullInvestmentIn","type":"uint256"}],"name":"estimateSwap","outputs":[{"internalType":"uint256","name":"swapAmountIn","type":"uint256"},{"internalType":"uint256","name":"swapAmountOut","type":"uint256"},{"internalType":"address","name":"swapTokenOut","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"minimumAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}]
const ERC20abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]
const vaultAbi = [{"inputs":[{"internalType":"contract IStrategy","name":"_strategy","type":"address"},{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"uint256","name":"_approvalDelay","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"implementation","type":"address"}],"name":"NewStratCandidate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"implementation","type":"address"}],"name":"UpgradeStrat","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"approvalDelay","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"available","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"balance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"depositAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"earn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getPricePerFullShare","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"inCaseTokensGetStuck","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_implementation","type":"address"}],"name":"proposeStrat","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"stratCandidate","outputs":[{"internalType":"address","name":"implementation","type":"address"},{"internalType":"uint256","name":"proposedTime","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"strategy","outputs":[{"internalType":"contract IStrategy","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"upgradeStrat","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"want","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_shares","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"nonpayable","type":"function"}]
console.log(deployments);

const formatEther = ethers.utils.formatEther;
const parseEther = ethers.utils.parseEther;


window.NATIVE = 'WDOGE'
window.WETH = '0xB7ddC6414bf4F5515b52D8BdD69973Ae205ff101'
window.USDC = '0x765277EebeCA2e31912C9946eAe1021199B39C61'
window.HLH = '0xCF22f35C00dB5eA7ED94da6c176fB488E5dAd9cd'

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var natives = {
  '1337':{
    'native':'MATIC', 
    'name':'Localhost',
    'weth':'0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    'usdc':'0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    'hlh':'0x9D939E22D4a50025CDDAc3d26F9485e49F95D074',
    'pool':'0x82F4b15Ba71845FA8C86CF18DA849545A5734D9e',
    'vaults':['usd-polygon','hlh_usdc-polygon'],
    'explorer':'https://example.com/',
    'backref':1337
  },
  '2000':{
    'native':'WDOGE',
    'name':'DogeChain',
    'weth':'0xB7ddC6414bf4F5515b52D8BdD69973Ae205ff101',
    'usdc':'0x765277EebeCA2e31912C9946eAe1021199B39C61',
    'hlh':'0xCF22f35C00dB5eA7ED94da6c176fB488E5dAd9cd',
    'pool':'0x6696e1b83aae6e6a20634b4b2c5cc6d3f5708366',
    'vaults':['usd','hlh','hlh_wwdoge'],
    'explorer':'https://explorer.dogechain.dog/',
    'backref':2000
  },
  '137':{
    'native':'MATIC', 
    'name':'Polygon',
    'weth':'0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    'usdc':'0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    'hlh':'0x9D939E22D4a50025CDDAc3d26F9485e49F95D074',
    'pool':'0x82F4b15Ba71845FA8C86CF18DA849545A5734D9e',
    'vaults':['usd-polygon','hlh_usdc-polygon'],
    'explorer':'https://polygonscan.com/',
    'backref':137
  },
}

const stakingOps = {
  // "ftm": {
  //   "name": "Ftm",
  //   "symbol": "FTM",
  //   "desc": 'Deposit your FTM to earn FTM or beFTM',
  //   "decimals": 18,
  //   "hasSwap":["FTM"],
  //   "sharemult":1,
  //   "vaultAddress":"0x185647c55633A5706aAA3278132537565c925078",
  //   "depositCurrencies": ["FTM","beFTM","moobeFTM"],
  //   "withdrawCurrencies": ["FTM","beFTM","moobeFTM"],
  //   "currencies":{
  //     "FTM":'0x0000000000000000000000000000000000000000',
  //     "beFTM":'0x7381eD41F6dE418DdE5e84B55590422a57917886',
  //     "moobeFTM":'0x185647c55633A5706aAA3278132537565c925078'
  //   },
  //   "tokenDecimals":{
  //     "USDC":6
  //   },
  //   "info":[
  //     {
  //       summary:'How is this yield generanted?',
  //       details:'Yield is generated through 3 methods: liquidity mining, lending and reflections. Liquidity mining/lending opportunities are selected from stable, high-APY opportunities in the Ftm protocol. Reflections are adjusted dynamically between 0-20% to even out the APY during downturns'
  //     },
  //     {
  //       summary:'What are reflections?',
  //       details:'Reflections are small fees charged when withdrawing from the protocol which are then distributed to others users in the vault, You can minimize the amount you pay in reflections by withdrawing during good market conditions'
  //     },
  //     {
  //       summary:'What is beFTM',
  //       details:'beFTM or Beefy Escrowed Fantom is a fully-backed token pegged to the value of Fantom, developed by beefy finance. beFTM is always treated as being worth 1 FTM by scythe, regardless of market price'
  //     }
  //   ],
  //   "beefyVault":"beefy-beFTM",
  //   "contract":deployments[window.useChain][0].contracts.ScytheLock,
  //   "enter":deployments[window.useChain][0].contracts.ScytheEnter,
  //   "estimates":{
  //     "deposit":{
  //       "FTM":{
  //         "scythe":"estimateDepositETHScythe",
  //         "shares":"estimateDepositETH",
  //         "minshares":"estimateDepositWant",
  //       },
  //       "beFTM":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //       },
  //       "moobeFTM":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //         "direct":true,
  //       }
  //     }
  //   },
  //   "calcFee":async function(){

  //   },
  //   "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      
  //   },
  //   "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      
  //   }
  // },
  "usd": {
    "nativeChain":2000,
    "name":"USDC.m-USDC.s",
    "symbol":"USD",
    "want":"0xbcb74543C6cC593BbfB129Dd3cCa92f6BAa49b12",
    "vault":"0x1230269489A71B3a83e0Cf17eb73F535f3B390a4",
    "router":"0x6258c967337d3faf0c2ba3adae5656ba95419d5f",
    "zap":"0x369a7ab59C3D8050682e630b74313F6e7B3B6014",
    "decimals": 18,
    "chefIndex":0,
    "stable":"USDC",
    "desc": 'Deposit your stablecoins (WDOGE will be swapped for USDC), earn stablecoins',
    "hasSwap":[],
    "sharemult":1e14,//66184314
    "depositCurrencies": ["USDC.m","USDC.s","WDOGE"],
    "withdrawCurrencies": ["USDC.m","USDC.s","WDOGE"],//"USDC","DAI",
    "LPcoins":["USDC.m","USDC.s"], // REVERSE ORDER
    "LPorder":["USDC.m","USDC.s"], 
    "currencies":{
      "USDC.m":"0x765277EebeCA2e31912C9946eAe1021199B39C61",
      "USDC.s":"0x85C2D3bEBffD83025910985389aB8aD655aBC946",
      "WDOGE":window.WETH,
    },
    "apyref":1662920623000,
    "apycheck":{
      'scythe':1,
      'vault':3.293386944281308679,
    },
    "type":"LP",
    "LP":"0x9606d683d03f012dda296ef0ae9261207c4a5847",
    "Router":"0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52",
    "info":[
    {
      summary:'What counts as a "stablecoin"?',
      details:'In order to be considered stable by HellHound they are first thoroughly analyzed. Multiple criteria such as trustworthiness, size, history, and algorithmic components are considered. Currently only USDC and DAI from trusted bridges are supported.'
    },
    {
      summary:'How is this yield generanted?',
      details:'Yield is generated through 3 methods: liquidity mining, lending and reflections. Liquidity mining/lending opportunities are selected from stable, high-APY opportunities in the Dogechain ecosystem. Reflections are adjusted dynamically between 0-20% to even out the APY during downturns'
    },
    {
      summary:'What are reflections?',
      details:'Reflections are small fees charged when withdrawing from the protocol which are then distributed to others users in the vault, You can minimize the amount you pay in reflections by withdrawing during good market conditions'
    }],
    "contract":"contract:ScytheLock_USD",
    "ZapperHH":"contract:ZapperHH",
    "chef":"contract:MiniChefV2",
    "tokenDecimals":{
      "USDC.m":6,
      "USDC.s":6
    },
    "estimates":{
    },
    "calcFee":async function(){

    },
    "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      const token = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer)

      const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]||18);

      if(currency===chainInfo.native){
        await zapper.zapInLP(chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex,{
          value:parseEther(amount)
        });
      }else{
        const allowance = await token.allowance(account,this.ZapperHH.address)
        

        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        
        await zapper.zapInLP(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
      }
    },
    "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      console.log(currency,amount,enter,scytheLock,account,useMin,chainInfo)

      const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

      window.changeModalPart('(1/3) [unstaking]');
      
      const chef = new ethers.Contract(this.chef.address,this.chef.abi,window.signer);
      

      var tx = await chef.withdrawAndHarvest(this.chefIndex, inwei, account);
      //await tx.wait();
      console.log('withdrawn and harvested')

      const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

      
      window.changeModalPart('(2/3) [approving]');

      
      var tx2 = await lock.approve(this.ZapperHH.address,parseEther('1000000000'));
      await tx2.wait();
      await tx.wait();
      console.log('approved')

      const la = await lock.balanceOf(account);
      console.log('lock la ',la)

      window.changeModalPart('(3/3) [withdrawing]');

      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      var tx = await zapper.unzapFromVault(this.vault,lock.address,this.currencies[currency],la,0);
      await tx.wait();
    }
  },
  "hlh": {
    "nativeChain":2000,
    "name":"HLH Staking",
    "symbol":"HLH",
    "want":"0xCF22f35C00dB5eA7ED94da6c176fB488E5dAd9cd",
    "vault":"0x85003FFFA9569f6165f293787e6b50b7031237E1",
    "router":"0x6258c967337d3faf0c2ba3adae5656ba95419d5f",
    "zap":"0x369a7ab59C3D8050682e630b74313F6e7B3B6014",
    "decimals": 18,
    "chefIndex":1,
    "desc": 'Stake HLH to earn HLH rewards',
    "hasSwap":[],
    "sharemult":1,//66184314
    "depositCurrencies": ["HLH"],
    "withdrawCurrencies": ["HLH"],//"USDC","DAI",
    "LPcoins":["HLH","USDC.s"], // REVERSE ORDER
    "LPorder":["HLH","USDC.s"], 
    "currencies":{
      "HLH":"0xCF22f35C00dB5eA7ED94da6c176fB488E5dAd9cd",
      "WDOGE":window.WETH,
    },
    "apyref":1662920623000,
    "apycheck":{
      'scythe':1,
      'vault':1,
    },
    "type":"single",
    "LP":"0x9606d683d03f012dda296ef0ae9261207c4a5847",
    "Router":"0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52",
    "info":[
    {
      summary:'What is HLH staking?',
      details:'This vault allows you to stake your HLH directly in order to earn a yield'
    },
    ],
    "contract":"contract:ScytheLock_SHLH",
    "ZapperHH":"contract:ZapperHH",
    "chef":"contract:MiniChefV2",
    "tokenDecimals":{
      "HLH":18,
      "USDC.m":6,
      "USDC.s":6
    },
    "estimates":{
    },
    "calcFee":async function(){
    },
    "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      const token = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer)

      const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]||18);

      const allowance = await token.allowance(account,this.ZapperHH.address)
      
      if(allowance.lt(inwei)){
        window.changeModalPart('(1/2) [approving]');
        const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
        await tx.wait();
        window.changeModalPart('(2/2) [depositing]');
      }
      
      await zapper.zapInWant(this.currencies[currency],this.vault,this.contract.address,this.chefIndex,inwei);
    },
    "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      console.log(currency,amount,enter,scytheLock,account,useMin,chainInfo)

      const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

      window.changeModalPart('(1/3) [unstaking]');
      
      const chef = new ethers.Contract(this.chef.address,this.chef.abi,window.signer);
      

      var tx = await chef.withdrawAndHarvest(this.chefIndex, inwei, account);
      await tx.wait();
      console.log('withdrawn and harvested')

      window.changeModalPart('(2/3) [unlocking]');

      const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

      var tx2 = await lock.withdrawAll(account);
      await tx2.wait();

      window.changeModalPart('(3/3) [withdrawing]');

      const vault = new ethers.Contract(this.vault,vaultAbi,window.signer);

      var tx3 = await vault.withdrawAll();
      await tx3.wait();

    }
  },
  "hlh_wwdoge": {
    "nativeChain":2000,
    "name":"HLH/WWDOGE LP",
    "symbol":"HLH/WWDOGE LP",
    "want":"0x57d141a83401e77bfb4cf1f228f826034b325c56",
    "vault":"0xd7df4b712dBdf0bd7a491C426Cb625B01E116346",
    "router":"0x6258c967337d3faf0c2ba3adae5656ba95419d5f",
    "zap":"0x369a7ab59C3D8050682e630b74313F6e7B3B6014",
    "decimals": 18,
    "chefIndex":2,
    "desc": 'Deposit your LP, earn rewards. WDOGE will be zapped into the LP pair',
    "hasSwap":[],
    "sharemult":1,//66184314
    "depositCurrencies": ["WDOGE-HLH-LP","WDOGE"],
    "withdrawCurrencies": ["WDOGE-HLH-LP","WDOGE"],//"USDC","DAI",
    "LPcoins":["WDOGE","HLH"], // REVERSE ORDER
    "LPorder":["WDOGE","HLH"], 
    "currencies":{
      "USDC.m":"0x765277EebeCA2e31912C9946eAe1021199B39C61",
      "USDC.s":"0x85C2D3bEBffD83025910985389aB8aD655aBC946",
      "HLH":"0xCF22f35C00dB5eA7ED94da6c176fB488E5dAd9cd",
      "WDOGE-HLH-LP":"0x57d141a83401e77bfb4cf1f228f826034b325c56",
      "WDOGE":window.WETH,
      "WWDOGE":window.WETH,
    },
    "apyref":1662920623000,
    "apycheck":{
      'scythe':1,
      'vault':1,
    },
    "type":"LP",
    "LPtoken":"WDOGE-HLH-LP",
    "LP":"0x9606d683d03f012dda296ef0ae9261207c4a5847",
    "Router":"0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52",
    "info":[
    {
      summary:'What LP is being used',
      details:'This vault uses LP from the yodeswap HLH/WWDOGE pair'
    }],
    "contract":"contract:ScytheLock_HLH_WWDOGE",
    "ZapperHH":"contract:ZapperHH",
    "chef":"contract:MiniChefV2",//0x6129196Dbb6B5591579664966548452A42b34f10
    "tokenDecimals":{
      "USDC.m":6,
      "USDC.s":6
    },
    "estimates":{
    },
    "calcFee":async function(){

    },
    "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      const token = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer)

      const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]||18);

      

      if(currency===chainInfo.native){
        console.log('ZAP IN DIRECTLY: ',this.ZapperHH.address,chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex)
        await zapper.zapInLP(chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex,{
          value:parseEther(amount)
        });
      }else if(currency===this.LPtoken){
        const allowance = await token.allowance(account,this.ZapperHH.address)
        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        await zapper.zapInWant(this.currencies[currency],this.vault,this.contract.address,this.chefIndex,inwei);
      }else{
        const allowance = await token.allowance(account,this.ZapperHH.address)
        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        
        await zapper.zapInLP(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
      }
    },
    "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      console.log(currency,amount,enter,scytheLock,account,useMin,chainInfo)

      const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

      window.changeModalPart('(1/3) [unstaking]');
      
      const chef = new ethers.Contract(this.chef.address,this.chef.abi,window.signer);
      

      var tx = await chef.withdrawAndHarvest(this.chefIndex, inwei, account);

      if(currency===this.LPtoken){
        await tx.wait();
        console.log('withdrawn and harvested')

        window.changeModalPart('(2/3) [unlocking]');

        const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

        var tx2 = await lock.withdrawAll(account);
        await tx2.wait();

        window.changeModalPart('(3/3) [withdrawing]');

        const vault = new ethers.Contract(this.vault,vaultAbi,window.signer);

        var tx3 = await vault.withdrawAll();
        await tx3.wait();

      }else{
        console.log('withdrawn and harvested')

        const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

        
        window.changeModalPart('(2/3) [approving]');

        
        var tx2 = await lock.approve(this.ZapperHH.address,parseEther('1000000000'));
        await tx2.wait();
        await tx.wait();
        console.log('approved')

        const la = await lock.balanceOf(account);
        console.log('lock la ',la)

        window.changeModalPart('(3/3) [withdrawing]');

        const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
        var tx = await zapper.unzapFromVault(this.vault,lock.address,this.currencies[currency],la,0);
        await tx.wait();
      }
    }
  },
  // "usdold": {
  //   "name": "usd",
  //   "symbol": "USD",
  //   "decimals": 18,
  //   "desc": 'Deposit your stablecoins, earn stablecoins',
  //   "hasSwap":[],
  //   "vaultAddress":"0x5d2EF803D6e255eF4D1c66762CBc8845051B54dB",
  //   "sharemult":1e8,//66184314
  //   "depositCurrencies": ["USDC","DAI","mooSpiritUSDC-DAI"],
  //   "withdrawCurrencies": ["DAI+USDC","USDC","DAI","mooSpiritUSDC-DAI"],//"USDC","DAI",
  //   "LPcoins":["DAI","USDC"], // REVERSE ORDER
  //   "LPorder":["USDC","DAI"], 
  //   "currencies":{
  //     "USDC":"0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
  //     "DAI":"0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E",
  //     "mooSpiritUSDC-DAI":"0x5d2EF803D6e255eF4D1c66762CBc8845051B54dB"
  //   },
  //   "type":"LP",
  //   "LP":"0x9606d683d03f012dda296ef0ae9261207c4a5847",
  //   "Router":"0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52",
  //   "info":[
  //   {
  //     summary:'What counts as a "stablecoin"?',
  //     details:'In order to be considered stable by Scythe they must be voted in by the DAO. Multiple criteria such as trustworthiness, size, history, and algorithmic components are considered. Currently only USDC and DAI are supported.'
  //   },
  //   {
  //     summary:'How is this yield generanted?',
  //     details:'Yield is generated through 3 methods: liquidity mining, lending and reflections. Liquidity mining/lending opportunities are selected from stable, high-APY opportunities in the Fantom ecosystem. Reflections are adjusted dynamically between 0-20% to even out the APY during downturns'
  //   },
  //   {
  //     summary:'What are reflections?',
  //     details:'Reflections are small fees charged when withdrawing from the protocol which are then distributed to others users in the vault, You can minimize the amount you pay in reflections by withdrawing during good market conditions'
  //   }],
  //   "zap":"0x5618c4C0A9c024e77eb9A5b4424f492f94C86F14",
  //   "beefyVault":"spirit-dai-usdc",
  //   "contract":deployments[window.useChain][0].contracts.ScytheLock_stable,
  //   "enter":deployments[window.useChain][0].contracts.ScytheEnter_stable,
  //   "tokenDecimals":{
  //     "USDC":6
  //   },
  //   "estimates":{
  //     "deposit":{
  //       "USDC":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //       },
  //       "DAI":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //       },
  //       "DAI+USDC":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //       },
  //       "mooSpiritUSDC-DAI":{
  //         "scythe":"estimateDepositWantScythe",
  //         "shares":"estimateDepositWant",
  //         "minshares":"estimateDepositWant",
  //         "direct":true,
  //       }
  //     }
  //   },
  //   "calcFee":async function(){

  //   },
  //   "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      
      

  //     if(currency==="mooSpiritUSDC-DAI"){

  //       var want = new ethers.Contract(this.vaultAddress,ERC20abi,window.signer);

  //       const allowance = await want.allowance(account,enter.address);

  //       window.changeModalPart('(1/2) [approving]');
  //         if(allowance.lt(ethers.utils.parseEther(amount))){
  //           const tx = await want.approve(enter.address,ethers.utils.parseEther('1000000000000'));
  //           await tx.wait();
  //           window.changeModalPart('(2/2) [depositing]');
  //         }else{
  //           window.changeModalPart('');
  //         }
  //       var tx = await enter.deposit(ethers.utils.parseEther(amount), account);
  //       await tx.wait();



  //     }else{
  //       const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]);
  //       const want = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer);


  //       const allowance = await want.allowance(account,enter.address);

  //       const totaltx = (allowance.lt(inwei))?2:1;

  //       if(totaltx==2){
  //         window.changeModalPart('(1/2) [approving]');
  //       }

  //       if(allowance.lt(inwei)){
  //         const tx = await want.approve(enter.address,ethers.utils.parseEther('1000000000000'));
  //         await tx.wait();
  //       }
  //       if(totaltx==2){
  //         window.changeModalPart('(2/2) [depositing]');
  //       }

  //       const tx =  await enter.depositWithBeefy(this.zap, this.vaultAddress,1, this.currencies[currency], inwei,account);
  //       await tx.wait();
        
  //     }
     
      
  //   },
  //   "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){



  //     if(currency!=="mooSpiritUSDC-DAI"){
  //       window.changeModalPart('(1/2) [withdrawing]');
  //     }
      

  //     const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

  //     console.log('withdrawing '+ethers.utils.formatEther(inwei)+' '+currency);
  //     const want = new ethers.Contract(this.vaultAddress,ERC20abi,window.signer);
  //     console.log(want);

  //     var wantQty = await want.balanceOf(account);

  //     const tx = await scytheLock.withdraw(inwei, account);
  //     await tx.wait();

  //     wantQty = (await want.balanceOf(account)).sub(wantQty);

  //     console.log('withdrew ', ethers.utils.formatEther(wantQty),' of beefy vault shares');


  //     if(currency==="mooSpiritUSDC-DAI"){
  //     }else{
        
  //       const zap = new ethers.Contract(this.zap,unizapabi,window.signer);
  //       const allowance = await want.allowance(account,zap.address);
        
  //       if(allowance.lt(wantQty)){
  //         window.changeModalPart('(2/2) [approving]');
  //         const tx = await want.approve(zap.address,ethers.utils.parseEther('1000000000000'));
  //         await tx.wait();
  //       }

  //       window.changeModalPart('(2/2) [exiting LP]');

  //       if(currency==="DAI"||currency==="USDC"){
  //         const tx2 = await zap.beefOutAndSwap(this.vaultAddress, wantQty, this.currencies[currency], 1)
  //         await tx2.wait();
  //       }else{
  //         const tx2 = await zap.beefOut(this.vaultAddress, wantQty)
  //         await tx2.wait();
  //       }
        

  //       console.log('withdrew from beefy vault');

  //       // const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]);
  //       // const want = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer);

  //     }
  //       // if(currency==="FTM"){
  //       //   const tx = await scytheLock.withdrawETH(ethers.utils.parseEther(amount),ethers.utils.parseEther(amount*0.5+''), account);
  //       //   await tx.wait();
  //       // }else if(currency==="beFTM"){
  //       //   const moobeFTM = new ethers.Contract("0x185647c55633A5706aAA3278132537565c925078",[{"inputs":[{"internalType":"contract IStrategy","name":"_strategy","type":"address"},{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"uint256","name":"_approvalDelay","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"implementation","type":"address"}],"name":"NewStratCandidate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"implementation","type":"address"}],"name":"UpgradeStrat","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"approvalDelay","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"available","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"balance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"depositAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"earn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getPricePerFullShare","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"inCaseTokensGetStuck","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_implementation","type":"address"}],"name":"proposeStrat","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"stratCandidate","outputs":[{"internalType":"address","name":"implementation","type":"address"},{"internalType":"uint256","name":"proposedTime","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"strategy","outputs":[{"internalType":"contract IStrategy","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"upgradeStrat","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"want","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_shares","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"nonpayable","type":"function"}],window.signer)

  //       //   var delta = await moobeFTM.balanceOf(account);
  //       //   const tx = await window.scytheLock.withdraw(ethers.utils.parseEther(amount), account);
  //       //   await tx.wait();
  //       //   delta = (await moobeFTM.balanceOf(account)).sub(delta);

  //       //   console.log(ethers.utils.formatEther(delta));
          
  //       //   const tx2 = await moobeFTM.withdraw(delta);
  //       //   await tx2.wait();
          
  //       // }else if(currency==="moobeFTM"){
  //       //   const tx = await window.scytheLock.withdraw(ethers.utils.parseEther(amount), account);
  //       //   await tx.wait();
  //       // }
  //   }
  // },
  "usd-polygon": {
    "nativeChain":137,
    "inherit":"usd",
    "name":"USDC-DAI",
    "symbol":"USD",
    "want":"0x5b13b583d4317ab15186ed660a1e4c65c10da659",
    "vault":"0x8440DAe4E1002e83D57fbFD6d33E6F3684a35036",
    "router":"0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607",
    "zap":null,
    "decimals": 18,
    "chefIndex":0,
    "stable":"USDC",
    "desc": 'Deposit your stablecoins (MATIC will be swapped for USDC), earn stablecoins',
    "hasSwap":[],
    "sharemult":1e9,//66184314
    "depositCurrencies": ["USDC","DAI","MATIC"],
    "withdrawCurrencies": ["USDC","DAI","MATIC"],//"USDC","DAI",
    "LPcoins":["USDC","DAI"], // REVERSE ORDER
    "LPorder":["USDC","DAI"], 
    "currencies":{
      "USDC":"0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      "DAI":"0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      "MATIC":"0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    },
    "apyref":1682876892000,
    "apycheck":{
      'scythe':1,
      'vault':1.097490834222146488,
    },
    "type":"LP",
    "LP":"0x9606d683d03f012dda296ef0ae9261207c4a5847",
    "Router":"0x16327e3fbdaca3bcf7e38f5af2599d2ddc33ae52",
    "info":[
    {
      summary:'What counts as a "stablecoin"?',
      details:'In order to be considered stable by HellHound they are first thoroughly analyzed. Multiple criteria such as trustworthiness, size, history, and algorithmic components are considered. Currently only USDC and DAI from trusted bridges are supported.'
    },
    {
      summary:'How is this yield generanted?',
      details:'Yield is generated through 3 methods: liquidity mining, lending and reflections. Liquidity mining/lending opportunities are selected from stable, high-APY opportunities in the Dogechain ecosystem. Reflections are adjusted dynamically between 0-20% to even out the APY during downturns'
    },
    {
      summary:'What are reflections?',
      details:'Reflections are small fees charged when withdrawing from the protocol which are then distributed to others users in the vault, You can minimize the amount you pay in reflections by withdrawing during good market conditions'
    }],
    "contract":"contract:ScytheLock_USD",
    "ZapperHH":"contract:ZapperHH",
    "chef":"contract:MiniChefV2",
    "tokenDecimals":{
      "USDC":6,
    },
    "estimates":{
    },
    "calcFee":async function(){

    },
    "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      const token = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer)

      const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]||18);

      if(currency===chainInfo.native){
        await zapper.zapInLP(chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex,{
          value:parseEther(amount)
        });
      }else{
        const allowance = await token.allowance(account,this.ZapperHH.address)
        

        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        
        await zapper.zapInLP(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
      }
    },
    "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      console.log(currency,amount,enter,scytheLock,account,useMin,chainInfo)

      const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

      window.changeModalPart('(1/3) [unstaking]');
      
      const chef = new ethers.Contract(this.chef.address,this.chef.abi,window.signer);
      

      var tx = await chef.withdrawAndHarvest(this.chefIndex, inwei, account);
      //await tx.wait();
      console.log('withdrawn and harvested')

      const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

      
      window.changeModalPart('(2/3) [approving]');

      
      var tx2 = await lock.approve(this.ZapperHH.address,parseEther('1000000000'));
      await tx2.wait();
      await tx.wait();
      console.log('approved')

      const la = await lock.balanceOf(account);
      console.log('lock la ',la)

      window.changeModalPart('(3/3) [withdrawing]');

      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      var tx = await zapper.unzapFromVault(this.vault,lock.address,this.currencies[currency],la,0);
      await tx.wait();
    }
  },
  "hlh_usdc-polygon": {
    "nativeChain":137,
    "inherit":"hlh_wwdoge",
    "name":"HLH/USDC LP",
    "symbol":"HLH/USDC LP",
    "want":"0x82F4b15Ba71845FA8C86CF18DA849545A5734D9e",
    "vault":"contract:NullVault_HLH_USDC-address",
    "router":"0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607",
    "decimals": 18,
    "chefIndex":1,
    "desc": 'Deposit your LP, earn rewards. MATIC and USDC will be zapped into the LP pair',
    "hasSwap":[],
    "sharemult":1e6,//66184314
    "depositCurrencies": ["HLH-USDC-LP","USDC","MATIC"],
    "withdrawCurrencies": ["HLH-USDC-LP","USDC","MATIC"],//"USDC","DAI",
    "LPcoins":["USDC","HLH"], // REVERSE ORDER
    "LPorder":["USDC","HLH"], 
    "currencies":{
      "HLH":"0x9D939E22D4a50025CDDAc3d26F9485e49F95D074",
      "HLH-USDC-LP":"0x82F4b15Ba71845FA8C86CF18DA849545A5734D9e",
      "USDC":"0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      "MATIC":"0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270"
    },
    "apyref":1662920623000,
    "apycheck":{
      'scythe':1,
      'vault':1,
    },
    "type":"LP",
    "LPtoken":"HLH-USDC-LP",
    "LP":"0x82F4b15Ba71845FA8C86CF18DA849545A5734D9e",
    "Router":"0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607",
    "info":[
    {
      summary:'What LP is being used',
      details:(<>This vault uses LP from the apeswap HLH/USDC pair. You can get this LP by <a target="_blank" href="https://apeswap.finance/add-liquidity/0x9D939E22D4a50025CDDAc3d26F9485e49F95D074/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174">adding liquidity on apeswap.</a></>)
    }],
    "contract":"contract:ScytheLock_HLH_USDC",
    "ZapperHH":"contract:ZapperHH",
    "MatrixZap":"contract:Zapper",
    "chef":"contract:MiniChefV2",//0x6129196Dbb6B5591579664966548452A42b34f10
    "tokenDecimals":{
      "USDC":6,
    },
    "estimates":{
    },
    "calcFee":async function(){

    },
    "deposit": async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
      const token = new ethers.Contract(this.currencies[currency],ERC20abi,window.signer)

      const inwei = ethers.utils.parseUnits(amount,this.tokenDecimals[currency]||18);

      

      if(currency===chainInfo.native){
        console.log('ZAP IN DIRECTLY: ',this.ZapperHH.address,chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex)
        await zapper.zapInLP(chainInfo.weth,this.vault,parseEther(amount),0,this.contract.address,this.chefIndex,{
          value:parseEther(amount)
        });
      }else if(currency===this.LPtoken){
        const allowance = await token.allowance(account,this.ZapperHH.address)
        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        await zapper.zapInWant(this.currencies[currency],this.vault,this.contract.address,this.chefIndex,inwei);
      }else{
        const allowance = await token.allowance(account,this.ZapperHH.address)
        if(allowance.lt(inwei)){
          window.changeModalPart('(1/2) [approving]');
          const tx = await token.approve(this.ZapperHH.address,parseEther('1000000000'));
          await tx.wait();
          window.changeModalPart('(2/2) [depositing]');
        }

        console.log(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
        
        await zapper.zapInLP(this.currencies[currency],this.vault,inwei,0,this.contract.address,this.chefIndex);
      }
    },
    "withdraw":async function(currency,amount,enter,scytheLock,account,useMin,chainInfo){
      console.log(currency,amount,enter,scytheLock,account,useMin,chainInfo)

      const inwei = ethers.utils.parseEther(amount).div(this.sharemult);

      window.changeModalPart('(1/3) [unstaking]');
      
      const chef = new ethers.Contract(this.chef.address,this.chef.abi,window.signer);
      

      var tx = await chef.withdrawAndHarvest(this.chefIndex, inwei, account);

      if(currency===this.LPtoken){
        await tx.wait();
        console.log('withdrawn and harvested')

        window.changeModalPart('(2/3) [unlocking]');

        const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

        var tx2 = await lock.withdrawAll(account);
        await tx2.wait();

        window.changeModalPart('(3/3) [withdrawing]');

        const vault = new ethers.Contract(this.vault,vaultAbi,window.signer);

        var tx3 = await vault.withdrawAll();
        await tx3.wait();

      }else{
        console.log('withdrawn and harvested')

        const lock = new ethers.Contract(this.contract.address,this.contract.abi,window.signer);

        
        window.changeModalPart('(2/3) [approving]');

        
        var tx2 = await lock.approve(this.ZapperHH.address,parseEther('1000000000'));
        await tx2.wait();
        await tx.wait();
        console.log('approved')

        const la = await lock.balanceOf(account);
        console.log('lock la ',la)

        window.changeModalPart('(3/3) [withdrawing]');

        const zapper = new ethers.Contract(this.ZapperHH.address,this.ZapperHH.abi,window.signer);
        var tx = await zapper.unzapFromVault(this.vault,lock.address,this.currencies[currency],la,0);
        await tx.wait();
      }
    }
  },
  "dogedollar":{
    "nativeChain":2000,
    "functions":{
      "mint":{
        "name":"Mint DUSD",
        "ratiorange":[300,Infinity],
        "swap":["DOGE","DUSD"],
        "error":"add additional liquidity to mint more DUSD",
        "fn":function(){console.log("minting")},
      },
      "burn":{
        "name":"Burn DUSD",
        "ratiorange":[0,Infinity],
        "swap":["DUSD","DOGE"],
        "fn":function(){console.log("burning")},
      },
      "addLiquidity":{
        "name":"Add Liquidity",
        "ratiorange":[0,Infinity],
        "swap":["DOGE","LP"],
        "fn":function(){console.log("adding liquidity")},
      },
      "removeLiquidity":{
        "name":"Remove Liquidity",
        "ratiorange":[300,Infinity],
        "swap":["LP","DOGE"],
        "error":"action would take collateralization below minimum",
        "fn":function(){console.log("removing liquidity")},
      }
    },
    "currencies":{
      "USDC":"0x765277EebeCA2e31912C9946eAe1021199B39C61",
      "WDOGE":window.WETH,
    },
    "tokenDecimals":{
      "USDC":6,
      "DUSD":6,
      "LP":6,
    },
    "djed":"contract:Djed",
    "dogedollar":"contract:DogeDollar",
    "oracle":"contract:WitnetOracle",
  }
}

Object.keys(stakingOps).forEach((key) => {
  // loop through all stakingOps and apply inheritance (if it has the inherit key then it will inherit from that key)
  if(stakingOps[key].inherit){
    stakingOps[key] = {...stakingOps[stakingOps[key].inherit],...stakingOps[key]}
  }
});
//   // loop through all keys and look for contract properties (properties that start with contract:)
//   Object.keys(stakingOps[key]).forEach((key2) => {
//     if(key2.startsWith('contract:')){
//       // if it is a contract property then we need to load the contract

//     }
//   });
// });
window.stakingOps = stakingOps;
for(var vid in stakingOps){
  var vault = stakingOps[vid];
  vault.contracts = {};
  for(var prop in vault){
    if((typeof(vault[prop])=="string")&&vault[prop].startsWith('contract:')){
      vault.contracts[prop] = vault[prop].split(':')[1];
    }
  }
}
window.stakingOps = stakingOps;

function refreshContracts(chainId){
  for(var vid in stakingOps){
    var vault = stakingOps[vid];
    vault.native = !(chainId === vault.nativeChain || chainId === 1337); // does this vault need to be treated seperatly (read only and data from native chain)
    if(window.livetesting){
      vault.native = true; // require native for live test
    }
    for(var prop in vault.contracts){
      var contractName = vault.contracts[prop];
      var justAddress = false;
      if(contractName.endsWith('-address')){
        contractName = contractName.split('-')[0];
        console.log('just address for ',contractName)
        justAddress = true;
      }
      if(!vault.native){
        stakingOps[vid][prop] = deployments[chainId][0].contracts[contractName];
      }else{
        var nativeChain = vault.nativeChain;
        stakingOps[vid][prop] = deployments[nativeChain][0].contracts[contractName];
      }
      var userSpec = getParameterByName('contract-'+contractName.toLowerCase());
      if(userSpec){
        console.log('replacing contract address for ',contractName,' with ',userSpec);
        stakingOps[vid][prop].address = userSpec;
        stakingOps[vid][prop].userSpec = true;
      }

      if(justAddress){
        stakingOps[vid][prop] = stakingOps[vid][prop].address;
      }
    }
    if(vault.native){
      stakingOps[vid].useChain = vault.nativeChain;
    }else{
      stakingOps[vid].useChain = chainId;
    }

    console.log('refreshed contracts for ',vid,vault.name,' now on chain ',vault.useChain,vault.native ? '[native]' : '[not native]')
  }
}
refreshContracts(window.useChain);

function RedirectToHome(){
  const navigate = useNavigate();
  useEffect(() => {
    console.log('redirecting to home');
    navigate('/', { replace: true });
  }, []);
  return (
    <>
      <b>Redirecting to Home</b>
    </>
  );
}


// window.backref = 1337;

function App() {

  const allEthers = useEthers()
  // console.log(allEthers)
  window.allEthers = allEthers;
  const { switchNetwork, chainId } = useEthers()
  const [backref,setBackref] = useState(window.useChain);
  const navigate = useNavigate();

  const [chainInfo,setChainInfo] = useState(natives[window.useChain+'']);


  window.refreshUIForChain = function(chainid){
    if(chainid&&backref!==chainid){
      console.log('NEW CHAIN ID <<<< >>>> ',chainid);
      if(natives[chainid]){
        setChainInfo(natives[chainid]);
        if(window.changeNetwork){
          window.changeNetwork(natives[chainid].name);
        }
      }
      refreshContracts(chainid);
      navigate('/', { replace: true });
      setBackref(chainid);
    }
    
    // const navigate = useNavigate();
  }
  useEffect(() => {
    window.refreshUIForChain(chainId);
  },[chainId]);
  
  // console.log(deployments)
  // // Read more about useDapp on https://usedapp.io/
  // var scytheLock = deployments[window.useChain][0].contracts.ScytheEnter;
  // const { error: contractCallError, value: tokenBalance } =
  //   useCall({
  //      contract: new Contract(scytheLock.address,scytheLock.abi),
  //      method: "estETHFromShare",
  //     args : [ethers.utils.parseEther('0.1')]
  //   }) ?? {};
    
  //   useEffect(() => {
  //     if(contractCallError) {
  //       console.error("Error while calling contract:", contractCallError.message);
  //       return;
  //     }
  //     if(tokenBalance){
  //       console.log("PPFS:", tokenBalance[0],ethers.utils.formatEther(tokenBalance[0]));
  //     }
  //     console.log(deployments)
  //    // console.log(ethers.utils.formatEther(tokenBalance[0]));
  //   },[tokenBalance,contractCallError]);
  // useEffect(() => {
  //   console.log(window.provider);
  // },[]);

  // const ref = window.ref = createRef();

  // const { account } = useEthers()
  // const etherBalance = useEtherBalance(account)

  const { error } = useEthers()
  const href = useMatch('/');
  const terms = useMatch('/terms');
  const isssoon = useMatch('/soon');


  useEffect(() => {
    if (error) {
      console.log(error)
    }
  }, [error])

  const [open,setOpen] = useState(false);
  const [modalData,setModalData] = useState({
    title: '--',
    subtitle: '---',
    body: '---',
    icon:'loader'
  });
  const [modalPart,setModalPart] = useState(null);
  window.changeAlert = function(isOpen,data){
    setOpen(isOpen);
    setModalData(data);
    setModalPart(null);
  }
  window.changeModalPart = function(part){
    setModalPart(part);
  }
  

  return (
    <>
      {isssoon?(<></>):<Header chainInfo={chainInfo} />}
      <MainStyle size={(href||terms)?"content":"tight"} style={{marginTop:'81px'}}>
          {/* Ether balance:
          <p className="bold">{ethers.utils.formatEther(etherBalance[0])} ETH</p> */}
        {/* <BalanceViewer settings={stakingOps['usd']} /> */}
        
        <Routes>
            <Route path="/soon" element={<Soon/>} />
            <Route path="/" element={<Landing chainInfo={chainInfo} settings={stakingOps}/>} />
            <Route path="/terms" element={<Terms/>} />
            {
              chainInfo.vaults.map((vault,i) => {
                return (
                  <Route key={i} path={"/"+vault} element={<Staking key={vault} chainInfo={chainInfo} settings={stakingOps[vault]}/>} />
                )
              })
            }
            {/* DogeDollar interface, but only if the user is on dogechain or localhost*/}
            {
              // (chainInfo.name==="Dogechain"||chainInfo.name==="Localhost")?(
                
              // ):(<></>)
            }
            <Route path="/dogedollar" element={<DogeDollar chainInfo={chainInfo} settings={stakingOps['dogedollar']}/>} />
            <Route key={1000000} path='*' exact={true} element={<RedirectToHome/>} />
            {/* <Redirect to="/" /> */}

          
          {/* <Redirect to="/" /> */}
          {/* <Route path="/usd" element={<Staking key={'usdstaking'} chainInfo={chainInfo} settings={stakingOps['usd']}/>} />
          <Route path="/usd-polygon" element={<Staking key={'usdstaking-polygon'} chainInfo={chainInfo} settings={stakingOps['usd-polygon']}/>} />
          <Route path="/hlh" element={<Staking key={'hlhstaking'} chainInfo={chainInfo} settings={stakingOps['hlh']}/>} />
          <Route path="/hlh-wwdoge" element={<Staking key={'hlhstaking'} chainInfo={chainInfo} settings={stakingOps['hlh_wwdoge']}/>} /> */}
        </Routes>

        <Modal
          center
          open={open}
          onClose={modalData.icon==='loader'?(null):(function(){setOpen(false)})}
          subtitle={modalData.subtitle}
          title={modalPart?(modalData.title+' '+modalPart):(modalData.title)}
          titleIcon={modalData.icon==='loader'?(<Loader size="large" />):((modalData.icon==='success')?(<Success color="green" height={64} width={64}/>):(<Error color="red" height={64} width={64}/>))}
        >
          <br />
          <Text
            color="secondary"
            size="xxs"
          >
            {modalData.body}
          </Text>
        </Modal>
          
      </MainStyle>
      {isssoon?(<></>):<Footer />}
    </>
  );
}

export default App;
